import { c as _c } from "react/compiler-runtime";
import { useWaveParticipationRendererSet } from "./participationRendererRegistry";
import type { ParticipationDropProps } from "./participationRenderer.types";
export default function ParticipationDrop(props) {
  const $ = _c(3);
  const {
    ParticipationDrop: ParticipationDropRenderer
  } = useWaveParticipationRendererSet(props.drop.wave.id);
  let t0;
  if ($[0] !== ParticipationDropRenderer || $[1] !== props) {
    t0 = <ParticipationDropRenderer {...props} />;
    $[0] = ParticipationDropRenderer;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}